import * as Sentry from "@sentry/browser";

import { userSelector } from "../redux/reducers/Common";
import { getAppVersion } from "./Number";
import { apiErrorCodes } from "../api/ApiResponse";

export function captureError(state, apiError) {
  if (process.env.REACT_APP_ENV === "local") {
    console.log("Error", apiError);
  }

  let error = apiError;
  if (typeof apiError === "string") {
    error = new Error(apiError);
  } else if (apiError?.errorMessage) {
    const includesHttpStatuses = [404].includes(apiError.httpStatus);
    const includesErrorCodes = Object.values(apiErrorCodes).includes(apiError.errorCode);
    if (includesHttpStatuses || includesErrorCodes || apiError.isCancel === true) {
      console.log("apiError", apiError);
      return;
    }
    error = new Error(apiError.errorMessage);
  }

  Sentry.withScope(function(scope) {
    scope.setTag("api_exception");
    scope.setExtras({
      userId: userSelector(state) ? userSelector(state).id : "",
      appVersion: getAppVersion()
    });
    Sentry.captureException(
      error,
      apiError?.errorMessage
        ? {
            extra: {
              ...apiError
            }
          }
        : undefined
    );
  });
}
